<!-- ANGULAR 12 MIGRATED COMPONENT -->

<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (isLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!isLoading) {
<form name="accountEditForm" novalidate>
    <div class="panel panel-default" style="margin-top:12px">
      <div class="panel-body">
        <div class="form-group">
          <div class="form-row">
            <div class="col-input col-md-width">
              <label for="accounts-dropdown">Account*</label>
              <ap-dropdown class="field-full-width" [list]="accountDropdownItems" [selectType]="'single'"
                inputId="accounts-dropdown" [title]="'Account'" [hideTitleOnInput]="true" [inputAriaLabel]="'Account'"
                [disabled]="accountsLoading"
                [(ngModel)]="selectedAccountItem" [ngModelOptions]="{standalone: true}"
                (onSelect)="onAccountDropdownSelect($event)">
                @for (item of accountDropdownItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Account')"
                    (onSelectItem)="onAccountSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
              @if (!selectedAccount && isSaveClicked) {
<span class="form-error-container"
                   >Account is required.</span>
}
              <hr/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
}
</div>

<!-- Standard Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isFormInvalid || isSaveClicked || crudLoading"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
